import React from 'react';
import {Routes, Route } from 'react-router-dom';
import Bookings from './admin/Bookings';
import Events from './admin/Events.jsx';
import Guests from './admin/Guests';
import Members from './admin/Members';
import Dashboard from './admin/Dashboard';
import ClubManagement from './admin/ClubManagement';
import AdminTournaments from './admin/Tournaments';
import { Box } from '@mui/material';

const Admin = () => {
    return (
        <Box>
            <Routes>
                <Route path="" element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="members" element={<Members />} />
                <Route path="bookings" element={<Bookings />} />
                <Route path="guests" element={<Guests />} />
                <Route path="events" element={<Events />} />
                <Route path="tournaments" element={<AdminTournaments />} />
                <Route path="club" element={<ClubManagement />} />
            </Routes>
        </Box>
    )
}
export default Admin;